module.exports = __webpack_public_path__ + "static/img/platformstatus1.768a17f7.svg";